export enum TransportSheetType {
  KIT = 'KIT',
  KIT_BATCH = 'KIT_BATCH',
  SELF_PRINT = 'SELF_PRINT',
  FACTORY_TO_CLIENT = 'FACTORY_TO_CLIENT',
}
